import type { IState } from 'redux/state';
import { createSelector } from 'reselect';
import type { Currency } from 'types/account';
import { keyBy } from 'utils/typesafe';
import { getAccountCurrency } from './accounts';

export const getCurrencies = (state: IState) => state.currencies;

/**
 * Returns a lookup of currencies by ID. Lookups for IDs that don't exist will instead return the
 * default currency.
 */
export const getCurrenciesById = createSelector(
  [getCurrencies, getAccountCurrency],
  (currencies, defaultCurrency): Record<string | symbol, Currency> => {
    const currencyMap = keyBy(currencies, 'id');
    const proxy = new Proxy(currencyMap, {
      get: (target, key) => (key in target ? target[key.toString()] : defaultCurrency),
    });
    return proxy;
  }
);
